import { BASE_SUBMISSION_V2_ROUTE } from './form-submission.constant';
import { getFormSubmissionV2Route } from './form-submissions.utils';

export const FORM_SUBMISSION_V2_ROUTES = {
  base: BASE_SUBMISSION_V2_ROUTE,
  goTo: getFormSubmissionV2Route,
};
